/**
 * Controller: TemplatesShowAccountsModal
 */
angular.module('acme.view.application.templates.showTemplatesModal.controllers', [
  'ui.router',
  'ui.bootstrap',
  'acme.common.service.api',
  'acme.common.service.helpers',
  'acme.common.service.templates.helpers',
  'acme.common.factory.gridState',
  'acme.common.factory.gridDefinition'
])
.controller('TemplatesShowModalController', [ '$scope', '$state', '$timeout', '$uibModalInstance', 'ApiService', 'HelpersService', 'GridStateFactory', 'GridDefinitionFactory', 'TemplatesHelpersService', 'selectedTemplate', function ($scope, $state, $timeout, $uibModalInstance, ApiService, HelpersService, GridStateFactory, GridDefinitionFactory, TemplatesHelpersService, selectedTemplate) {

  $scope.templatesShowModal = {

    model: [],
    errors: [],
    selected: '',
    searchQuery: '',
    isLoaded: false,
    isLoading: false,
    gridName: $state.current.name + '.modal.grid0',
    gridState: new GridStateFactory(),
    gridDefinition: new GridDefinitionFactory(),

    optionsOverride: {
      data: 'templatesShowModal.model',
      paginationPageSize: 10,
      paginationPageSizes: [10, 25],
      enableGridMenu: false,
      rowClasses: "{ 'ui-grid-row-header-cell': col.isRowHeader, 'private-event': (row.entity.type === 'private') || row.entity.offSchedule, 'programs-list-cancelled-row': row.entity.isCancelled }",
      getRowClass: function(params) {
        if (params.data.type === 'private' || params.data.offSchedule) {
          return "private-event";
        } else if (params.data.isCancelled) {
          return "programs-list-cancelled-row";
        } else {
          return null;
        }
      },
      columnDefs: [
        {
          field: 'name',
          displayName: 'Name',
          visible: true,
          cellTemplate: '<div class="ui-grid-cell-contents" style="height:100%;position: relative;padding-left: 10px;" data-ng-class="col.colIndex()">' +
          '<span data-ng-style="row.entity.colorCodeStyle"></span>' +
          '<span>{{ row.entity.name }}</span>' +
          '</div>',
          cellRenderer: function(params) {
            var value = '<div class="ui-grid-cell-contents" style="padding-left: 5px;">';
            if (params.data.colorCodeStyle) {
              value += $('<div />').append($('<span />').css(params.data.colorCodeStyle)).html();
            }
            value += '<span>' + params.data.name + '</span>';
            value = value + '</div>';
            return value;
          }
        },
        {
          field: 'admissionType',
          displayName: 'Type',
          headerTooltip: true,
          enableRowSelection: true,
          cellTemplate: '<div class="ui-grid-cell-contents" ng-class="col.colIndex()">' +
          '<span data-ng-show="row.entity.admissionType === \'standard\'">Standard</span>' +
          '<span data-ng-show="row.entity.admissionType === \'generalAdmission\'">General Admission</span>' +
          '</div>',
          cellRenderer: function(params) {
            var value = '<div class="ui-grid-cell-contents">';
            if (params.data.admissionType === 'generalAdmission') {
              value += '<span>General Admission</span>';
            }else{
              value += '<span>Standard</span>';
            }
            value = value + '</div>';
            return value;
          },
          visible: true,
          enableHiding: false,
          suppressSizeToFit: true
        },
        {
          field: 'reviewState',
          displayName: 'Review State',
          visible: true
        }
      ],
      appScopeProvider: {
        onDblClick: function(row) {
          $scope.templatesShowModal.done();
        },
        onDataGridPaginate: function(newPageNumber, newPageSize, sortField, sortDirection) {
          $scope.templatesShowModal.onDataGridPaginate(newPageNumber, newPageSize, sortField, sortDirection);
        },
        onDataGridSortChange: function(grid, columns, page) {
          $scope.templatesShowModal.onDataGridSortChange(grid, columns, page);
        },
        onDataGridSelectionChange: function(row) {
          var self = $scope.templatesShowModal;

          if (self.gridDefinition.isAccessbilityEnabled) {
            if (row.isSelected) {
              self.selected = row.entity;
            }
          }else{
            if (row.node.selected) {
              self.selected = row.entity;
            }
          }
        }
      }
    },

    init: function() {
      this.isLoading = true;

      this.gridState.updateGridState(1, this.optionsOverride.pageSize, 'name', 'asc');
      this.gridDefinition.init(this.gridName, this.optionsOverride, $state.current.name, $state.current.data.enablePreferences);

      $scope.$on('$destroy', $scope.$on('DataGrid::UserPreferencesLoaded', this.initData));
    },

    initData: function() {
      $scope.templatesShowModal.getTemplateNames();
    },

    getTemplateNames: function() {
      ApiService.program.names(false, this.gridState.getGridState()).then(this.success.init, this.error.init);
    },

    findTemplate: function(id) {

      var i, ii,
          r = false;

      for (i=0,ii=this.model.length;i<ii;i++) {
        if (this.model[i].id === id) {
          r = {
            index: i,
            template: this.model[i]
          };
          break;
        }
      }

      return r;

    },
    query: function() {

      var self = $scope.templatesShowModal;

      if (this.queryTimer) {
        $timeout.cancel(this.queryTimer);
      }

      this.queryTimer = $timeout(function() {
        self.gridState.setPropertyValue('search', self.searchQuery);
        $scope.$broadcast('DataGrid::Search', { name: self.gridName });
      }, 350);

    },

    search: function() {

      this.isLoaded = false;

      if (this.gridDefinition.userPreferencesLoaded) {
        this.getTemplateNames();
      }

    },

    selectRow: function(template) {
      var found,
          self = $scope.templatesShowModal;

      $timeout(function() {
        self.lastSelected = template;
        if (template && template.id) {
          found = self.findTemplate(template.id);
          if (found) {
            self.model[found.index].isSelected = true;
            self.gridDefinition.selectRows([self.model[found.index]]);
          }
        }
      }, 0);

    },

    hasData: function() {
      return (this.model instanceof Array && this.model.length > 0);
    },

    hasErrors: function() {
      return (this.errors.length > 0);
    },

    done: function() {
      $uibModalInstance.close(this.selected);
    },

    cancel: function () {
      $uibModalInstance.dismiss('cancel');
    },

    process: function(templates) {
      var i, ii;

      for (i = 0, ii=templates.length; i < ii; i++) {
        templates[i].reviewState = HelpersService.cap(templates[i].reviewState);
        if (templates[i].colorCategory && templates[i].colorCategory.textColor) {
          templates[i].colorCodeStyle = TemplatesHelpersService.getColorCategoryStyle(templates[i].colorCategory);
        }
      }

      return templates;
    },

    success: {
      init: function(response) {
        var self = $scope.templatesShowModal;

        self.model = self.process(response.data.payload.list);

        self.isLoading = false;

        self.isLoaded = true;
        self.gridDefinition.isLoaded = true;

        $timeout(function() {

          $scope.$broadcast('DataGrid::ResizeGrid', {
            name: self.gridDefinition.options.gridName,
            datasetLength: self.model.length,
            totalItems: response.data.payload.pagination.count
          });

          self.selectRow(selectedTemplate);

        }, 300);

      }
    },
    error: {
      init: function (response) {
        var self = $scope.templatesShowModal;

        self.isLoading = false;
        self.isLoaded = true;
        self.gridDefinition.isLoaded = true;

        self.errors = [
          {
            message: response.data.error
          }
        ];
      }
    },

    onDataGridPaginate: function(newPage, pageSize, sortField, sortDirection) {

      var self = $scope.templatesShowModal;

      self.gridState.updateGridState(newPage, pageSize);

      if (sortField) {
        self.gridState.updateGridState(null, null, sortField, null);
      }

      if(sortDirection) {
        self.gridState.updateGridState(null, null, null, sortDirection);
      }

      self.getTemplateNames();

    },

    onDataGridSortChange: function(grid, columns, page) {

      var self = $scope.templatesShowModal,
          data = columns[0];

      self.gridState.updateGridState(page || null, null, data.field, data.sort.direction);
      self.getTemplateNames();

    }

  };

  $scope.templatesShowModal.init();

}]);